<template>
  <div class="container-content">
    <div
      class="tracker-container"
      v-if="container !== null && container !== ''"
    >
      <div class="tile-content">
        <div class="d-flex justify-content-between">
          <small class="text-uppercase"
            ><b-icon-hash /> {{ container.container_number }}</small
          >
          <small class="text-uppercase" v-if="container.company"
            ><b-icon-building /> {{ container.company }}</small
          >
          <small class="text-uppercase" v-if="container.currentVessel"
            ><b-icon-truck /> {{ container.currentVessel }}</small
          >
        </div>
        <status :cc="cc" :cs="cs" />
      </div>
      <!--Link for Modal -->
      <footer class="tile-footer mt-3">
        <small>
          <b-link v-b-modal="containerId" class="nav-link p-0">{{
            $t('invoices.tracking.container.showMore')
          }}</b-link>
        </small>
      </footer>
    </div>
    <div class="no-data" v-else-if="container === ''">
      <loader :height="200" />{{ $t('invoices.tracking.container.fetch') }}
    </div>
    <div class="data-fetch" v-else>
      {{ $t('invoices.tracking.container.noData') }}
    </div>
  </div>
</template>

<script>
import Status from '@/components/invoices/tracking/Status'
import Loader from '@/components/common/Loader'
import platformService from '@/services/platform'

export default {
  data() {
    return {
      container: '',
      cc: {},
      cs: 1
    }
  },
  props: ['containerId', 'invoiceShippingData', 'token'],
  computed: {
    getInvoiceAuthToken() {
      return !this.$store.state.account.accountId
        ? this.$route.params.auth_token
        : ''
    }
  },
  methods: {
    getContainer() {
      platformService
        .fetchContainerByInvoice(
          this.containerId,
          this.$route.params.id,
          this.getInvoiceAuthToken,
          this.token
        )
        .then((res) => {
          if (JSON.parse(res.data.events).length > 1) {
            this.container = res.data
            this.$emit('containersLoaded', res.data)
            this.prettyData()
          } else {
            this.container = null
            this.$emit('containersLoaded', null)
          }
        })
    },
    prettyData() {
      this.cc = {
        arrival: {
          location:
            this.container.discharge_port !== null
              ? this.container.discharge_port.split(',')[0].split('(')[0].trim()
              : this.invoiceShippingData.port_of_discharge !== null
              ? this.invoiceShippingData.port_of_discharge
              : (this.container = null),
          time:
            this.container.actual_arrival_at_discharge ||
            this.container.expected_arrival_at_discharge
        },
        departure: {
          location:
            this.container.loading_port !== null
              ? this.container.loading_port.split(',')[0].split('(')[0].trim()
              : this.invoiceShippingData.shipping_port !== null
              ? this.invoiceShippingData.shipping_port
              : (this.container = null),
          time:
            this.container.actual_arrival_at_loading ||
            this.container.expected_arrival_at_loading
        },
        current: {
          location:
            this.container &&
            this.container.current_location &&
            this.container.current_location.split(',')[0].split('(')[0].trim(),
          time: this.container.current_location_time
        }
      }
      this.currentState()
    },
    currentState() {
      if (
        this.cc.current.location === this.cc.arrival.location &&
        this.cc.current.location !== null
      ) {
        this.cs = 3
      } else if (
        this.cc.current.location === this.cc.departure.location &&
        this.cc.current.location !== null
      ) {
        this.cs = 1
      } else {
        this.cs = 2
      }
    }
  },
  created() {
    // this.getContainer()
  },
  components: {
    Status,
    Loader
  }
}
</script>

<style lang="scss" scoped>
.container-content {
  position: relative;
  height: 100%;
  .no-data,
  .data-fetch {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    width: 100%;
    height: 100%;
  }
}
</style>
